import styled from 'styled-components'

export const Content = styled.div`
	display: grid;
	grid-template-columns: calc(50% - 64px) 1fr;
	column-gap: 64px;
	justify-content: center;
	width: 100%;
	max-width: 1600px;

	@media only screen and (max-width: 1500px) {
		grid-template-columns: 1fr;
	}
`
